var components
try {
  components = {
    uCellGroup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-cell-group/u-cell-group" */ "uview-ui/components/u-cell-group/u-cell-group.vue"
      )
    },
    uCellItem: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-cell-item/u-cell-item" */ "uview-ui/components/u-cell-item/u-cell-item.vue"
      )
    },
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 =
    _vm.active && !_vm.$slots.default && !_vm.$slots.$default
      ? _vm.$u.addUnit(_vm.height)
      : null
  var l0 =
    _vm.active && !_vm.$slots.default && !_vm.$slots.$default
      ? _vm.__map(_vm.options, function (item, index) {
          var $orig = _vm.__get_orig(item)

          var a0 = {
            color:
              _vm.value == item.value ? _vm.activeColor : _vm.inactiveColor,
          }
          return {
            $orig: $orig,
            a0: a0,
          }
        })
      : null

  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      $event.stopPropagation()
      $event.preventDefault()
      return (function () {})($event)
    }

    _vm.e1 = function ($event) {
      $event.stopPropagation()
      $event.preventDefault()
      return (function () {})($event)
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }